import React from 'react';
import Navbar from '../components/Navbar/navbar';
import Sendgrade from '../components/admin/grade';

function GradeSend() {

  return (
    <div className='newAdmin'>   
    <Navbar/>
    <Sendgrade/>
    </div>
  )
}

export default GradeSend;
